import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lightning } from "@phosphor-icons/react";

const ROLES = ["marketing_manager", "content_creator", "performance_marketer", "influencer_manager", "designer"];

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "content_creator" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm" style={{ animation: "fade-up 0.5s ease-out both" }}>
        <div className="mb-8 flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-brand-violet to-brand-pink">
            <Lightning size={22} weight="fill" className="text-white" />
          </div>
          <p className="font-display text-lg font-black">Asymmetry Edits</p>
        </div>
        <h1 className="font-display text-3xl font-black">Join the team</h1>
        <p className="mt-1 text-sm text-muted-foreground">Create your marketing workspace account.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div className="space-y-1.5">
            <Label>Full name</Label>
            <Input data-testid="register-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="rounded-xl" required />
          </div>
          <div className="space-y-1.5">
            <Label>Email</Label>
            <Input data-testid="register-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="rounded-xl" required />
          </div>
          <div className="space-y-1.5">
            <Label>Password</Label>
            <Input data-testid="register-password" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} className="rounded-xl" required />
          </div>
          <div className="space-y-1.5">
            <Label>Role</Label>
            <select data-testid="register-role" value={form.role} onChange={(e) => set("role", e.target.value)} className="flex h-10 w-full rounded-xl border border-input bg-surface-raised px-3 text-sm">
              {ROLES.map((r) => <option key={r} value={r}>{r.replace(/_/g, " ")}</option>)}
            </select>
          </div>
          {error && <p data-testid="register-error" className="text-sm text-brand-pink">{error}</p>}
          <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full rounded-full bg-gradient-to-r from-brand-violet to-brand-pink py-6 text-white">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mt-6 text-center text-sm text-muted-foreground">
          Already have an account? <Link to="/login" className="font-semibold text-primary">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
